import { __decorate } from "tslib";
import React, { cloneElement, Component, isValidElement } from 'react';
import { observer } from 'mobx-react';
import { action, isArrayLike, observable, runInAction, toJS } from 'mobx';
import uniq from 'lodash/uniq';
import pull from 'lodash/pull';
import noop from 'lodash/noop';
import map from 'lodash/map';
import isObject from 'lodash/isObject';
import isEnumEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isFunction from 'lodash/isFunction';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import { getConfig, getProPrefixCls } from 'choerodon-ui/lib/configure';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import Icon from 'choerodon-ui/lib/icon';
import { Action } from 'choerodon-ui/lib/trigger/enum';
import { RecordStatus } from '../../data-set/enum';
import Button from '../../button';
import Dropdown from '../../dropdown';
import TextField from '../../text-field';
import Tooltip from '../../tooltip';
import { $l } from '../../locale-context';
import autobind from '../../_util/autobind';
import isEmpty from '../../_util/isEmpty';
import FieldList from './FieldList';
import TableButtons from './TableButtons';
import ColumnFilter from './ColumnFilter';
import QuickFilterMenu from './quick-filter';
/**
 * 当前数据是否有值并需要选中
 * @param data
 */
function isSelect(data) {
    if (isObject(data[1])) {
        return !isEnumEmpty(data[1]);
    }
    return data[0] !== '__dirty' && !isEmpty(data[1]);
}
function isEqualDynamicProps(originalValue, newValue) {
    if (isEqual(newValue, originalValue)) {
        return true;
    }
    if (isObject(newValue) && isObject(originalValue) && Object.keys(newValue).length) {
        return Object.keys(newValue).every(key => {
            const value = newValue[key];
            const oldValue = originalValue[key];
            if (oldValue === value) {
                return true;
            }
            const oEp = isNumber(oldValue) ? isEmpty(oldValue) : isEnumEmpty(oldValue);
            const nEp = isNumber(value) ? isEmpty(value) : isEnumEmpty(value);
            if (oEp && nEp) {
                return true;
            }
            return isEqual(oldValue, value);
        });
    }
    return isEqual(newValue, originalValue);
}
let TableDynamicFilterBar = class TableDynamicFilterBar extends Component {
    constructor(props, context) {
        super(props, context);
        this.refDropdown = null;
        this.refSingleWrapper = null;
        this.refEditors = new Map();
        this.originalConditionFields = [];
        this.handleClickOut = (e) => {
            if (this.refDropdown && !this.refDropdown.contains(e.target)) {
                this.fieldSelectHidden = true;
            }
        };
        this.setOriginalConditionFields = (code) => {
            if (!code) {
                this.originalConditionFields = [];
            }
            else {
                const codes = Array.isArray(code) ? code : [code];
                this.originalConditionFields = uniq([...this.originalConditionFields, ...codes]);
            }
            this.selectFields = [...this.originalConditionFields];
        };
        /**
         * 勾选
         * @param code
         */
        this.handleSelect = (code) => {
            const codes = Array.isArray(code) ? code : [code];
            this.selectFields = uniq([...this.selectFields, ...codes]);
            const shouldUpdate = !isEqual(toJS(this.selectFields), toJS(this.originalConditionFields));
            this.setConditionStatus(shouldUpdate ? RecordStatus.update : RecordStatus.sync);
        };
        /**
         * 取消勾选
         * @param code
         */
        this.handleUnSelect = (code) => {
            const { queryDataSet } = this.props;
            const codes = Array.isArray(code) ? code : [code];
            if (queryDataSet) {
                codes.map((name) => {
                    if (queryDataSet.current) {
                        queryDataSet.current.set(name, undefined);
                    }
                    return null;
                });
            }
            this.selectFields = pull([...this.selectFields], ...codes);
            const shouldUpdate = !isEqual(toJS(this.selectFields), toJS(this.originalConditionFields));
            this.setConditionStatus(shouldUpdate ? RecordStatus.update : RecordStatus.sync);
        };
        runInAction(() => {
            this.fieldSelectHidden = true;
            this.selectFields = [];
            this.expand = true;
        });
    }
    componentDidMount() {
        this.processDataSetListener(true);
        document.addEventListener('click', this.handleClickOut);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOut);
        this.processDataSetListener(false);
    }
    processDataSetListener(flag) {
        const { queryDataSet } = this.props;
        if (queryDataSet) {
            const handler = flag ? queryDataSet.addEventListener : queryDataSet.removeEventListener;
            handler.call(queryDataSet, 'validate', this.handleDataSetValidate);
            handler.call(queryDataSet, 'update', this.handleDataSetUpdate);
            handler.call(queryDataSet, 'create', this.handleDataSetCreate);
        }
    }
    /**
     * queryDataSet 查询前校验事件 触发展开动态字段
     * @param dataSet 查询DS
     * @param result
     */
    async handleDataSetValidate({ dataSet, result }) {
        if (!await result) {
            const fields = [...dataSet.fields.keys()];
            map(fields, field => {
                if (!dataSet.current.getField(field).isValid()) {
                    this.handleSelect(field);
                }
            });
            runInAction(() => {
                this.expand = true;
            });
            this.refSingleWrapper.style.height = '';
            this.refSingleWrapper.style.overflow = '';
        }
    }
    setConditionStatus(value, orglValue) {
        runInAction(() => this.conditionStatus = value);
        if (value === RecordStatus.sync && orglValue) {
            this.originalValue = orglValue;
        }
    }
    /**
     * 筛选条件更新 触发表格查询
     */
    handleDataSetUpdate({ record }) {
        const { dataSet, onQuery = noop, autoQuery } = this.props;
        let status = RecordStatus.update;
        if (record) {
            status = isEqualDynamicProps(this.originalValue, record.toData()) ? RecordStatus.sync : RecordStatus.update;
        }
        this.setConditionStatus(status);
        if (autoQuery) {
            dataSet.query();
            onQuery();
        }
    }
    /**
     * queryDS 新建，初始勾选值
     */
    handleDataSetCreate({ dataSet, record }) {
        const conditionData = Object.entries(record.toData());
        this.originalValue = record.toData();
        const keys = [...dataSet.fields.keys()];
        map(conditionData, data => {
            let name = data[0];
            if (!keys.includes(data[0]) &&
                isObject(data[1]) &&
                !isEnumEmpty(data[1]) &&
                !isArray(data[1])) {
                name = `${data[0]}.${Object.keys(data[1])[0]}`;
            }
            if (isSelect(data) && !dataSet.getField(name).get('bind')) {
                if (!this.selectFields.includes(name)) {
                    this.originalConditionFields.push(name);
                    this.handleSelect(name);
                }
            }
        });
    }
    /**
     * tableFilterSuffix 预留自定义区域
     */
    renderSuffix() {
        const { prefixCls, dynamicFilterBar, queryDataSet, dataSet, buttons } = this.props;
        const suffixes = dynamicFilterBar?.suffixes || getConfig('tableFilterSuffix');
        const children = [];
        let suffixesDom = null;
        const tableButtons = buttons.length ? (React.createElement(TableButtons, { key: "toolbar", prefixCls: `${prefixCls}-dynamic-filter`, buttons: buttons })) : null;
        if (suffixes && suffixes.length) {
            suffixes.forEach(suffix => {
                if (suffix === 'filter') {
                    children.push(React.createElement(ColumnFilter, { prefixCls: prefixCls }));
                }
                else if (isValidElement(suffix)) {
                    children.push(suffix);
                }
                else if (isFunction(suffix)) {
                    children.push(suffix({ queryDataSet, dataSet }));
                }
            });
            suffixesDom = (React.createElement("div", { className: `${prefixCls}-dynamic-filter-bar-suffix` }, children));
        }
        return [
            tableButtons,
            suffixesDom,
        ];
    }
    getPrefix() {
        const { prefixCls, dynamicFilterBar, queryDataSet, dataSet } = this.props;
        const prefixes = dynamicFilterBar?.prefixes;
        const children = [];
        if (prefixes && prefixes.length) {
            prefixes.forEach((prefix) => {
                if (isString(prefix) && prefix === 'filter') {
                    children.push(React.createElement(ColumnFilter, { prefixCls: prefixCls }));
                }
                else if (isValidElement(prefix)) {
                    children.push(prefix);
                }
                else if (isFunction(prefix)) {
                    children.push(prefix({ queryDataSet, dataSet }));
                }
            });
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `${prefixCls}-dynamic-filter-bar-prefix` }, children),
                React.createElement("span", { className: `${prefixCls}-filter-search-divide` })));
        }
        return null;
    }
    /**
     * 注入 onEnterDown 事件
     * @param element
     * @param name
     */
    createFields(element, name) {
        const { onEnterDown } = element.props;
        if (onEnterDown && isFunction(onEnterDown)) {
            return element;
        }
        const props = {
            onEnterDown: () => {
                this.handleQuery();
            },
            ref: (node) => this.refEditors.set(name, node),
        };
        return cloneElement(element, props);
    }
    /**
     * 判断查询值是否为空
     * @param value
     */
    isEmpty(value) {
        return isArrayLike(value) ? !value.length : isEmpty(value);
    }
    get tableFilterAdapter() {
        const { dynamicFilterBar } = this.props;
        return dynamicFilterBar?.tableFilterAdapter || getConfig('tableFilterAdapter');
    }
    /**
     * 是否单行操作
     */
    isSingleLineOpt() {
        const { fuzzyQuery } = this.props;
        return !(fuzzyQuery || this.tableFilterAdapter);
    }
    /**
     * 渲染展开逻辑
     * @param hidden 是否隐藏全部
     */
    getExpandNode(hidden) {
        const { prefixCls } = this.props;
        return (React.createElement("span", { className: `${prefixCls}-filter-menu-expand`, onClick: () => {
                const { height } = this.refSingleWrapper.getBoundingClientRect();
                const { height: childHeight } = this.refSingleWrapper.children[0].children[0].getBoundingClientRect();
                runInAction(() => {
                    this.expand = hidden ? height <= 0 : height <= (childHeight + 18);
                });
                if (hidden && height) {
                    // 收起全部
                    this.refSingleWrapper.style.display = 'none';
                }
                else {
                    this.refSingleWrapper.style.display = 'flex';
                    this.refSingleWrapper.style.height = '';
                    this.refSingleWrapper.style.overflow = '';
                }
                if (height > (childHeight + 18) && !hidden) {
                    // 收起留一行高度
                    this.refSingleWrapper.style.height = pxToRem(childHeight + 18) || '';
                    this.refSingleWrapper.style.overflow = 'hidden';
                }
                else {
                    this.refSingleWrapper.style.height = '';
                    this.refSingleWrapper.style.overflow = '';
                }
            } }, this.expand ? (React.createElement(Tooltip, { title: $l('Table', 'collapse') },
            React.createElement(Icon, { type: "baseline-arrow_drop_up" }))) : (React.createElement(Tooltip, { title: $l('Table', 'expand_button') },
            React.createElement(Icon, { type: "baseline-arrow_drop_down" })))));
    }
    /**
     * 渲染模糊搜索
     */
    getFuzzyQuery() {
        const { prefixCls, dataSet, dynamicFilterBar, autoQueryAfterReset, fuzzyQuery, fuzzyQueryPlaceholder, onReset = noop } = this.props;
        const searchText = dynamicFilterBar?.searchText || getConfig('tableFilterSearchText') || 'params';
        const placeholder = fuzzyQueryPlaceholder || $l('Table', 'enter_search_content');
        if (!fuzzyQuery)
            return null;
        return (React.createElement("div", { className: `${prefixCls}-filter-search` },
            React.createElement(TextField, { style: { width: 280 }, clearButton: true, placeholder: placeholder, prefix: React.createElement(Icon, { type: "search" }), value: this.searchText, onChange: () => noop, onClear: () => {
                    runInAction(() => {
                        this.searchText = '';
                    });
                    onReset();
                    if (autoQueryAfterReset) {
                        dataSet.setQueryParameter(searchText, undefined);
                        this.handleQuery(true);
                    }
                }, onInput: (e) => {
                    // @ts-ignore
                    const { value } = e.target;
                    runInAction(() => {
                        this.searchText = value || '';
                    });
                    dataSet.setQueryParameter(searchText, value);
                    this.handleQuery();
                } })));
    }
    /**
     * 渲染重置按钮
     */
    getResetButton() {
        const { prefixCls, queryDataSet, autoQueryAfterReset, onReset = noop } = this.props;
        return (React.createElement("div", { className: `${prefixCls}-filter-buttons` }, this.conditionStatus === RecordStatus.update && React.createElement(Button, { onClick: () => {
                if (queryDataSet && queryDataSet.current) {
                    queryDataSet.current.reset();
                }
                this.handleDataSetCreate({ dataSet: queryDataSet, record: queryDataSet?.current });
                this.setConditionStatus(RecordStatus.sync);
                onReset();
                if (autoQueryAfterReset) {
                    this.handleQuery();
                }
            } }, $l('Table', 'reset_button'))));
    }
    /**
     * 筛选头
     * fuzzyQuery + quickFilterMenu + resetButton + buttons
     */
    getFilterMenu() {
        const { prefixCls, queryFields, queryDataSet, dataSet, dynamicFilterBar, searchCode, autoQuery } = this.props;
        if (queryDataSet && queryFields.length) {
            const prefix = this.getPrefix();
            const fuzzyQuery = this.getFuzzyQuery();
            const quickFilterMenu = this.tableFilterAdapter && searchCode ? (React.createElement(QuickFilterMenu, { autoQuery: autoQuery, prefixCls: prefixCls, expand: this.expand, dynamicFilterBar: dynamicFilterBar, searchCode: searchCode, dataSet: dataSet, queryDataSet: queryDataSet, onChange: this.handleSelect, conditionStatus: this.conditionStatus, onStatusChange: this.setConditionStatus, selectFields: this.selectFields, onOriginalChange: this.setOriginalConditionFields })) : null;
            const resetButton = this.isSingleLineOpt() || this.tableFilterAdapter ? null : this.getResetButton();
            const expandNode = this.getExpandNode(true);
            return (React.createElement("div", { className: `${prefixCls}-filter-menu` },
                prefix,
                fuzzyQuery,
                quickFilterMenu,
                resetButton,
                this.isSingleLineOpt() ? null : (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: `${prefixCls}-filter-search-divide` }),
                    expandNode)),
                this.renderSuffix()));
        }
    }
    /**
     * 渲染查询条
     */
    getQueryBar() {
        const { prefixCls, queryFieldsLimit = 3, queryFields, queryDataSet } = this.props;
        const singleLineModeAction = this.isSingleLineOpt() ? React.createElement("div", { className: `${prefixCls}-dynamic-filter-bar-single-action` },
            this.getResetButton(),
            this.getExpandNode(false)) : null;
        if (queryDataSet && queryFields.length) {
            return (React.createElement("div", { key: "query_bar", className: `${prefixCls}-dynamic-filter-bar` },
                this.getFilterMenu(),
                React.createElement("div", { className: `${prefixCls}--dynamic-filter-single-wrapper`, ref: (node) => this.refSingleWrapper = node },
                    React.createElement("div", { className: `${prefixCls}-filter-wrapper` },
                        queryFields.slice(0, queryFieldsLimit).map(element => {
                            const { name, hidden } = element.props;
                            if (hidden)
                                return null;
                            const queryField = queryDataSet.getField(name);
                            const itemClassName = `${prefixCls}-filter-item`;
                            return (React.createElement("div", { className: `${prefixCls}-filter-content`, key: name, onClick: () => this.refEditors.get(name).focus() },
                                React.createElement("span", { className: `${prefixCls}-filter-label` }, queryField?.get('label')),
                                React.createElement("span", { className: itemClassName }, this.createFields(element, name))));
                        }),
                        queryFields.slice(queryFieldsLimit).map(element => {
                            const { name, hidden } = element.props;
                            if (hidden)
                                return null;
                            const queryField = queryDataSet.getField(name);
                            if (this.selectFields.includes(name)) {
                                return (React.createElement("div", { className: `${prefixCls}-filter-content`, key: name, onClick: () => this.refEditors.get(name).focus() },
                                    React.createElement(Icon, { type: "cancel", className: `${prefixCls}-filter-item-close`, onClick: () => {
                                            this.handleUnSelect([name]);
                                        } }),
                                    React.createElement("span", { className: `${prefixCls}-filter-label` }, queryField?.get('label')),
                                    React.createElement("span", { className: `${prefixCls}-filter-item` }, this.createFields(element, name))));
                            }
                            return null;
                        }),
                        (queryFieldsLimit < queryFields.length) && (React.createElement("div", { className: `${prefixCls}-filter-item` },
                            React.createElement(Dropdown, { visible: !this.fieldSelectHidden, overlay: (React.createElement("div", { role: "none", ref: (node) => this.refDropdown = node, onClick: (e) => {
                                        e.stopPropagation();
                                    } },
                                    React.createElement(FieldList, { groups: [{
                                                title: $l('Table', 'predefined_fields'),
                                                fields: [...queryDataSet.fields.values()].filter(f => !f.get('bind')).slice(queryFieldsLimit),
                                            }], prefixCls: `${prefixCls}-filter-list` || 'c7n-pro-table-filter-list', closeMenu: () => runInAction(() => this.fieldSelectHidden = true), value: this.selectFields, onSelect: this.handleSelect, onUnSelect: this.handleUnSelect }))), trigger: [Action.click] },
                                React.createElement("span", { className: `${prefixCls}-add-fields`, onClick: (e) => {
                                        e.nativeEvent.stopImmediatePropagation();
                                        runInAction(() => {
                                            this.fieldSelectHidden = false;
                                        });
                                    } },
                                    React.createElement(Icon, { type: "add" }),
                                    $l('Table', 'add_filter')))))),
                    singleLineModeAction)));
        }
        return null;
    }
    handleQuery(collapse) {
        const { dataSet, onQuery = noop, autoQuery } = this.props;
        if (autoQuery) {
            dataSet.query();
        }
        if (!collapse) {
            onQuery();
        }
    }
    render() {
        const { summaryBar, buttons, prefixCls } = this.props;
        const queryBar = this.getQueryBar();
        if (queryBar) {
            return [queryBar, summaryBar];
        }
        return React.createElement(TableButtons, { key: "toolbar", prefixCls: `${prefixCls}-dynamic-filter-buttons`, buttons: buttons }, summaryBar);
    }
};
TableDynamicFilterBar.defaultProps = {
    prefixCls: getProPrefixCls('table'),
    queryFieldsLimit: 3,
    autoQueryAfterReset: true,
    fuzzyQuery: true,
    autoQuery: true,
};
__decorate([
    observable
], TableDynamicFilterBar.prototype, "moreFields", void 0);
__decorate([
    observable
], TableDynamicFilterBar.prototype, "fieldSelectHidden", void 0);
__decorate([
    observable
], TableDynamicFilterBar.prototype, "selectFields", void 0);
__decorate([
    observable
], TableDynamicFilterBar.prototype, "expand", void 0);
__decorate([
    observable
], TableDynamicFilterBar.prototype, "searchText", void 0);
__decorate([
    observable
], TableDynamicFilterBar.prototype, "conditionStatus", void 0);
__decorate([
    action
], TableDynamicFilterBar.prototype, "handleClickOut", void 0);
__decorate([
    autobind
], TableDynamicFilterBar.prototype, "handleDataSetValidate", null);
__decorate([
    autobind
], TableDynamicFilterBar.prototype, "setConditionStatus", null);
__decorate([
    action
], TableDynamicFilterBar.prototype, "setOriginalConditionFields", void 0);
__decorate([
    autobind
], TableDynamicFilterBar.prototype, "handleDataSetUpdate", null);
__decorate([
    autobind
], TableDynamicFilterBar.prototype, "handleDataSetCreate", null);
__decorate([
    action
], TableDynamicFilterBar.prototype, "handleSelect", void 0);
__decorate([
    action
], TableDynamicFilterBar.prototype, "handleUnSelect", void 0);
__decorate([
    autobind
], TableDynamicFilterBar.prototype, "handleQuery", null);
TableDynamicFilterBar = __decorate([
    observer
], TableDynamicFilterBar);
export default TableDynamicFilterBar;
